import { render, staticRenderFns } from "./VehicleServiceHistoryGridBlock.vue?vue&type=template&id=5e23b3e6&scoped=true"
import script from "./VehicleServiceHistoryGridBlock.vue?vue&type=script&lang=js"
export * from "./VehicleServiceHistoryGridBlock.vue?vue&type=script&lang=js"
import style0 from "./VehicleServiceHistoryGridBlock.vue?vue&type=style&index=0&id=5e23b3e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e23b3e6",
  null
  
)

export default component.exports